import React from 'react';
import { Site } from '@ritabygglov/core';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';
import { useUser } from '../../context/User/useUser';
import { siteConfig } from '../../config/siteConfig';
import { DrawblueprintLogo, RitabygglovLogo } from '../Icons';

const LOGO_SCALE = 0.4;

const LOGO_BY_SITE: Record<
  Site,
  { Logo: React.FC<{ fill?: string }>; width: number }
> = {
  ritabygglov: { Logo: RitabygglovLogo, width: 1258 },
  drawblueprint: { Logo: DrawblueprintLogo, width: 1446 },
};

export const Watermark: React.FC<{
  opacity?: number;
  color?: string;
  size?: number;
}> = ({ opacity = 0.12, color = '#0048A3' }) => {
  const user = useUser();
  const { pathname } = useLocation();
  const intl = useIntl();
  const isExportRoute = pathname.includes('/projects/export');

  if (user.isSubscribed || isExportRoute) return null;

  const { Logo, width } = LOGO_BY_SITE[siteConfig.site];

  return (
    <g pointerEvents="none">
      <g transform="translate(800 530) rotate(0)" opacity={opacity}>
        <g
          transform={`translate(${-(width * LOGO_SCALE) / 2} 0) scale(${LOGO_SCALE})`}
        >
          <Logo fill={color} />
        </g>
      </g>
      <g transform="translate(800 670) rotate(0)">
        <text
          textAnchor="middle"
          fontFamily="Inter, Arial, sans-serif"
          fontWeight={500}
          fontSize={20}
          fill={color}
          opacity={opacity}
          letterSpacing={2}
        >
          {intl.formatMessage({ id: 'watermark.text' })}
        </text>
      </g>
    </g>
  );
};
